<template>
  <div class="index-container">
    <Header></Header>
    <div class="schedule-container">
      <div class="schedule-header">
        <div class="left">
          <div class="date-control">
            <el-button-group>
              <el-button icon="el-icon-arrow-left" size="small" @click="changeMonth(-1)"></el-button>
              <el-button size="small" @click="backToToday">今天</el-button>
              <el-button icon="el-icon-arrow-right" size="small" @click="changeMonth(1)"></el-button>
            </el-button-group>
            <span class="current-date">{{ currentYear }}年{{ currentMonth }}月</span>
          </div>
        </div>
        <div class="right">
          <el-button type="text" icon="el-icon-refresh" @click="refreshCalendar">刷新</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="showAddDialog">新建日程</el-button>
        </div>
      </div>
      
      <div class="calendar-wrapper">
        <div class="week-header">
          <div class="week-item" v-for="day in weekDays" :key="day">{{ day }}</div>
        </div>
        
        <div class="calendar-body">
          <div v-for="(week, weekIndex) in calendarDays" 
               :key="weekIndex" 
               class="week-row">
            <div v-for="(day, dayIndex) in week" 
                 :key="dayIndex" 
                 class="day-cell"
                 :class="{ 
                   'other-month': day.isOtherMonth,
                   'is-today': isToday(day.date)
                 }">
              <div class="day-header">
                <span class="date-number">{{ day.dayNumber }}</span>
                <span v-if="getSchedulesByDate(day.date).length" class="schedule-count">
                  {{ getSchedulesByDate(day.date).length }}个日程
                </span>
              </div>
              <div class="schedule-list" v-if="getSchedulesByDate(day.date).length">
                <div v-for="(schedule, index) in getSchedulesByDate(day.date)"
                     :key="index"
                     class="schedule-item "
                     :class="[schedule.type, { 'is-completed': schedule.completed }]"
                     :data-cate="schedule.cate">
                  <div class="time" v-if="schedule.cate == 'case'">{{ schedule.time }}</div>
                  <div class="time" @click="editSchedule(schedule)" v-else>{{ schedule.time }}</div>
                  <div class="schedule-content " >
                    <span v-if="schedule.cate === 'case'" class="case-tag">案</span>
                    <el-tooltip 
                      :content="schedule.title" 
                      placement="top" 
                      :enterable="false"
                      :manual="false"
                      effect="dark"
                      popper-class="schedule-tooltip">
                      <span class="title mouse-pointer" @click="showScheduleDetail(schedule)" v-if="schedule.cate == 'case'">{{ schedule.title }}</span>
                      <span  class="title"  @click="editSchedule(schedule)" v-else>{{ schedule.title }}</span>
                    </el-tooltip>
                  </div>
                 
                  <el-checkbox v-model="schedule.completed" @change="handleScheduleStatusChange(schedule)" :disabled="schedule.cate == 'case'"></el-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 新建日程对话框 -->
      <el-dialog
        title="新建日程"
        :visible.sync="dialogVisible"
        width="500px"
        :close-on-click-modal="false">
        <el-form :model="newSchedule" :rules="rules" ref="scheduleForm" label-width="80px">
          <el-form-item label="日期" prop="date">
            <el-date-picker
              v-model="newSchedule.date"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              style="width: 100%">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="时间" prop="time">
            <el-time-picker
              v-model="newSchedule.timeValue"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="选择时间"
              style="width: 100%">
            </el-time-picker>
          </el-form-item>
          <el-form-item label="标题" prop="title">
            <el-input v-model="newSchedule.title" placeholder="请输入日程标题"></el-input>
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-select v-model="newSchedule.type" placeholder="请选择日程类型" style="width: 100%">
              <el-option label="普通" value="normal"></el-option>
              <el-option label="重要" value="important"></el-option>
              <el-option label="警告" value="warning"></el-option>
              <el-option label="信息" value="info"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitSchedule" :loading="submitting">确 定</el-button>
        </span>
      </el-dialog>
      
      <!-- 编辑日程对话框 -->
      <el-dialog
        title="编辑日程"
        :visible.sync="editDialogVisible"
        width="500px"
        :close-on-click-modal="false">
        <el-form :model="editingSchedule" :rules="rules" ref="editScheduleForm" label-width="80px">
          <el-form-item label="日期" prop="date">
            <el-date-picker
              v-model="editingSchedule.date"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              style="width: 100%">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="时间" prop="timeValue">
            <el-time-picker
              v-model="editingSchedule.timeValue"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="选择时间"
              style="width: 100%">
            </el-time-picker>
          </el-form-item>
          <el-form-item label="标题" prop="title">
            <el-input v-model="editingSchedule.title" placeholder="请输入日程标题"></el-input>
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-select v-model="editingSchedule.type" placeholder="请选择日程类型" style="width: 100%">
              <el-option label="普通" value="normal"></el-option>
              <el-option label="重要" value="important"></el-option>
              <el-option label="警告" value="warning"></el-option>
              <el-option label="信息" value="info"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitEditSchedule" :loading="submitting">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import { getCalendarDays } from '@/utils/calendar'
import caseApi from '@/api/case'
import axios from 'axios'  // 确保已安装并引入 axios

export default {
  name: "Index",
  components: { Header },
  data() {
    const currentMonth = new Date().getMonth() + 1
    const currentYear = new Date().getFullYear()
    
    return {
      weekDays: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      currentDate: new Date(),
      scheduleList: [],
      dialogVisible: false,
      submitting: false,
      newSchedule: {
        date: '',
        timeValue: '',
        title: '',
        type: 'normal'
      },
      rules: {
        date: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ],
        timeValue: [
          { required: true, message: '请选择时间', trigger: 'change' }
        ],
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ]
      },
      editDialogVisible: false,
      editingSchedule: {
        id: '',
        date: '',
        timeValue: '',
        title: '',
        type: ''
      }
    }
  },
  computed: {
    currentMonth() {
      return this.currentDate.getMonth() + 1
    },
    currentYear() {
      return this.currentDate.getFullYear()
    },
    calendarDays() {
      return getCalendarDays(this.currentDate)
    }
  },
  async created() {
    await this.fetchScheduleList()
  },
  methods: {
    // 编辑日程
    editSchedule(schedule) {
      this.editingSchedule = {
        id: schedule.id,
        date: schedule.date,
        timeValue: schedule.time,
        title: schedule.title,
        type: schedule.type
      }
      this.editDialogVisible = true
    },

    // 提交编辑的日程
    async submitEditSchedule() {
      this.$refs.editScheduleForm.validate(async (valid) => {
        if (valid) {
          this.submitting = true
          try {
            const scheduleData = {
              id: this.editingSchedule.id,
              date: this.editingSchedule.date,
              time: this.editingSchedule.timeValue,
              title: this.editingSchedule.title,
              type: this.editingSchedule.type
            }
            // console.log(scheduleData);
            // return;

            // 调用更新接口
            await caseApi.updateSchedule(scheduleData)
            
            // 重新获取日程列表
            await this.fetchScheduleList()
            
            this.editDialogVisible = false
            this.$message.success('日程更新成功')
          } catch (error) {
            this.$message.error('更新失败，请重试')
            console.error('更新日程失败:', error)
          } finally {
            this.submitting = false
          }
        }
      })
    },

    showScheduleDetail(schedule) {
      window.open(`/cases/info?id=${schedule.caseid}`, '_blank')
    },

    // 判断是否是今天
    isToday(date) {
      const today = new Date()
      return date.getFullYear() === today.getFullYear() &&
             date.getMonth() === today.getMonth() &&
             date.getDate() === today.getDate()
    },
    
    // 格式化日期为 YYYY-MM-DD 格式
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    
    // 获取指定日期的日程
    getSchedulesByDate(date) {
      const dateStr = this.formatDate(date)
      return this.scheduleList.filter(schedule => schedule.date === dateStr)
    },
    
    // 获取日程列表
    async fetchScheduleList() {
      try {
        const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        console.log(this.currentYear);
        console.log(this.currentMonth);
        // 调用后台接口获取日程数据
        const response = await caseApi.getScheduleList({
          year: this.currentYear,
          month: this.currentMonth
        })
        if(response.status != 200) {
          this.$loading().close();
          this.$router.push('/login');
          return;
        }
        console.log(response);
        this.scheduleList = response.data.map(item => ({
          ...item,
          completed: Boolean(item.completed) // 确保 completed 是布尔值
        }))

        loading.close()
      } catch (error) {
        this.$loading().close();
        this.$message.error('获取日程数据失败')
        console.error('获取日程失败:', error)
      }
    },
    
    // 处理日程状态变更
    async handleScheduleStatusChange(schedule) {
      try {

        if(schedule.cate == 'case') {
          this.$message.success('请到案件详情中更新')
          return;
        }

        const loading = this.$loading({
          lock: true,
          text: '更新中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
       
        // 调用后台接口
        await caseApi.updateScheduleStatus({
          id: schedule.id,
          completed: schedule.completed
        })

        loading.close()

        this.$message({
          type: 'success',
          message: schedule.completed ? '日程已标记为完成' : '日程已标记为未完成'
        })

      } catch (error) {
        // 更新失败,回滚状态
        schedule.completed = !schedule.completed
        this.$message.error('更新失败，请重试')
        console.error('更新日程状态失败:', error)
      }
    },

    // 添加错误处理方法
    handleError(error) {
      if (error.response) {
        // 服务器返回错误状态码
        switch (error.response.status) {
          case 401:
            this.$message.error('请先登录')
            // 可以在这里处理登录跳转
            break
          case 403:
            this.$message.error('没有权限执行此操作')
            break
          case 404:
            this.$message.error('请求的资源不存在')
            break
          case 500:
            this.$message.error('服务器内部错误')
            break
          default:
            this.$message.error('操作失败，请重试')
        }
      } else if (error.request) {
        // 请求发出但没有收到响应
        this.$message.error('网络连接失败，请检查网络')
      } else {
        // 请求配置出错
        this.$message.error('请求配置错误')
      }
    },
    
    // 切换月份
    async changeMonth(offset) {
      const newDate = new Date(this.currentDate)
      newDate.setMonth(newDate.getMonth() + offset)
      this.currentDate = newDate
      // 切换月份后重新获取数据
      await this.fetchScheduleList()
    },
    
    // 返回今天
    async backToToday() {
      this.currentDate = new Date()
      await this.fetchScheduleList()
      this.$message.success('已定位到今天')
    },
    
    // 刷新日历
    async refreshCalendar() {
      await this.fetchScheduleList()
      this.$message.success('日程已更新')
    },
    
    // 显示新建日程对话框
    showAddDialog() {
      this.dialogVisible = true
      this.newSchedule = {
        date: this.formatDate(new Date()),
        timeValue: '09:00',
        title: '',
        type: 'normal'
      }
      // 如果表单实例存在，重置验证
      if (this.$refs.scheduleForm) {
        this.$refs.scheduleForm.resetFields()
      }
    },
    
    // 提交新日程
    async submitSchedule() {
      this.$refs.scheduleForm.validate(async (valid) => {
        if (valid) {
          this.submitting = true
          try {
            const scheduleData = {
              date: this.newSchedule.date,
              time: this.newSchedule.timeValue,
              title: this.newSchedule.title,
              type: this.newSchedule.type
            }

            // 创建日程
            await caseApi.createSchedule(scheduleData)
            
            // 重新获取日程列表
            await this.fetchScheduleList()
            
            this.dialogVisible = false
            this.$message.success('日程创建成功')
          } catch (error) {
            this.$message.error('创建失败，请重试')
            console.error('创建日程失败:', error)
          } finally {
            this.submitting = false
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.index-container {
  min-height: 100vh;
  background: #f0f2f5;

  box-sizing: border-box;
}

.schedule-container {
  width: 95%;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  margin: 24px auto;
  
  .schedule-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid #f0f0f0;
    
    .left {
      display: flex;
      align-items: baseline;
      
      .date-control {
        display: flex;
        align-items: center;
        margin-top: 12px;
        
        .el-button-group {
          margin-right: 16px;
        }
        
        .current-date {
          font-size: 14px;
          color: #262626;
          font-weight: 500;
        }
      }
      
      h3 {
        margin: 0;
      }
    }
    
    .right {
      display: flex;
      gap: 12px;
    }
  }
  
  .calendar-wrapper {
    padding: 20px;
    
    .week-header {
      display: grid;
      grid-template-columns: repeat(7, minmax(0, 1fr));
      text-align: center;
      padding: 10px 0;
      border-bottom: 1px solid #f0f0f0;
      
      .week-item {
        color: #8c8c8c;
        font-size: 14px;
        width: 100%;
        box-sizing: border-box;
      }
    }
    
    .calendar-body {
      .week-row {
        display: grid;
        grid-template-columns: repeat(7, minmax(0, 1fr));
        border-bottom: 1px solid #f0f0f0;
        
        &:last-child {
          border-bottom: none;
        }
      }
      
      .day-cell {
        min-height: 150px;
        padding: 8px;
        border-right: 1px solid #f0f0f0;
        width: 100%;
        box-sizing: border-box;
        
        &:last-child {
          border-right: none;
        }
        
        &.other-month {
          background: #fafafa;
          .date-number {
            color: #bfbfbf;
          }
        }
        
        &.is-today {
          background: rgba(24,144,255,0.04);
          
          .date-number {
            background: #1890ff;
            color: #fff;
            border-radius: 50%;
            width: 28px;
            height: 28px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 500;
          }
        }
        
        .day-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;
          
          .schedule-count {
            font-size: 12px;
            color: #8c8c8c;
          }
        }
        
        .schedule-list {
          overflow-y: auto;
          max-height: calc(100% - 32px);
          
          &::-webkit-scrollbar {
            width: 4px;
          }
          
          &::-webkit-scrollbar-thumb {
            background: #e8e8e8;
            border-radius: 2px;
          }
          
          .schedule-item {
            margin: 4px 0;
            padding: 4px 8px;
            border-radius: 4px;
            font-size: 12px;
            display: flex;
            flex-direction: column;
            gap: 4px;
            position: relative;
            
            // 基础类型样式
            &.important {
              background: #fff1f0;
              color: #ff4d4f;
              border-left: 2px solid #ff4d4f;
            }
            
            &.warning {
              background: #fff7e6;
              color: #faad14;
              border-left: 2px solid #faad14;
            }
            
            &.normal {
              background: #e6f7ff;
              color: #1890ff;
              border-left: 2px solid #1890ff;
            }
            
            &.info {
              background: #f5f5f5;
              color: #8c8c8c;
              border-left: 2px solid #8c8c8c;
            }

            // 案件类型特殊样式
            &[data-cate="case"] {
              &.important {
                background: #f9e9e9;
                color: #d4380d;
                border-left: 2px solid #d4380d;
                font-weight: 500;
              }
              
              &.warning {
                background: #fff2e8;
                color: #d46b08;
                border-left: 2px solid #d46b08;
                font-weight: 500;
              }
              
              &.normal {
                background: #e6fffb;
                color: #006d75;
                border-left: 2px solid #006d75;
                font-weight: 500;
              }
            }
            
            // 已完成状态
            &.is-completed {
              opacity: 0.7;
              background: #f5f5f5;
              border-left-color: #52c41a;
              
              .time, .title, .case-tag {
                color: #8c8c8c;
                text-decoration: line-through;
              }

              .case-tag {
                background: rgba(0, 0, 0, 0.05);
              }
            }
            
            .time {
              flex: 0 0 auto;
              font-weight: 500;
              font-size: 11px;
              opacity: 0.85;
            }
            
            .schedule-content {
              flex: 1;
              display: flex;
              align-items: flex-start;
              min-width: 0;
              margin-right: 8px;
              
              .case-tag {
                flex-shrink: 0;
                font-size: 12px;
                padding: 1px 4px;
                border-radius: 2px;
                background: rgba(0, 0, 0, 0.1);
                margin-right: 6px;
                color: inherit;
              }
              
              .title {
                flex: 1;
                word-break: break-all;
                white-space: normal;
                line-height: 1.4;
                cursor: pointer;
              }

              .title2 {
                flex: 1;
                word-break: break-all;
                white-space: normal;
                line-height: 1.4;
              }
            }
          }
        }
      }
    }
  }
}

// 优化日期单元格样式
.day-cell {
  &.is-today {
    background: rgba(24,144,255,0.04);
    
    .date-number {
      background: #1890ff;
      color: #fff;
      border-radius: 50%;
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
    }
  }
  
  &.other-month {
    background: #fafafa;
    
    .schedule-item {
      opacity: 0.6;
    }
  }
}

// 添加过渡动画
.calendar-body {
  transition: all 0.3s ease;
}

// 添加新样式
:deep(.el-dialog__body) {
  padding: 20px 20px 0 20px;
}

:deep(.el-select) {
  width: 100%;
}

.dialog-footer {
  padding: 20px;
  text-align: right;
}

// 添加 tooltip 样式
:deep(.schedule-tooltip) {
  max-width: 300px;
  font-size: 12px;
  padding: 8px 12px;
  line-height: 1.4;
}

.schedule-item {
  .schedule-content {
    .title {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: default;
      display: inline-block;
      width: 100%;
    }
  }
}

.mouse-pointer {
  cursor: pointer;
}
</style>
